import React from 'react';
import PropTypes from 'prop-types';
import { setActionTaken } from '../../../services';
import styles from './../../styles.module.scss';

const ConfirmExperience = ({ years, setStep, setAction }) => {
  /**
   * If the user confirms the years of experience, send to the BE the information
   * with the `setActionTaken` service, and set the current step
   * as done in order to show the Done banner.
   *
   * @returns {undefined}
   */
  const handleConfirm = () => {
    setActionTaken('experience_duration', 'verified');
    setAction('verifying');
    setStep('done');
  };

  return (
    <div className='text-center' data-testid='confirm-experience'>
      <p className={`mt-35 mb-15 ${styles.pitch}`}>
        Recently updated profiles appear higher on candidate search results.
      </p>
      <p className={`mb-35 ${styles.question}`}>
        Do you still have {years} {years > 1 ? 'years ' : 'year '}
        of experience in global development ?
      </p>
      <button className='btn btn-outline-primary btn-lg me-25' onClick={handleConfirm}>
        Yes, I do
      </button>
      <button
        className='btn btn-outline-primary btn-lg'
        onClick={() => {
          setStep('edit');
        }}
      >
        No, I don&apos;t
      </button>
    </div>
  );
};

ConfirmExperience.propTypes = {
  years: PropTypes.number,
  setStep: PropTypes.func,
  setAction: PropTypes.func,
};

export default ConfirmExperience;
